import { render, staticRenderFns } from "./SubStage.vue?vue&type=template&id=711a1426&scoped=true&"
import script from "./SubStage.vue?vue&type=script&lang=js&"
export * from "./SubStage.vue?vue&type=script&lang=js&"
import style0 from "./SubStage.vue?vue&type=style&index=0&id=711a1426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a1426",
  null
  
)

export default component.exports